













import {
  defineComponent,
  PropType,
  ref,
  toRefs,
  watch
} from '@nuxtjs/composition-api'
import { Option } from '~/models/shared/types'

export default defineComponent({
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array as PropType<Option[]>,
      default() {
        return []
      }
    }
  },
  setup(props: any, { emit }: any) {
    const { enabled } = toRefs(props)
    const internalEnabled = ref(enabled.value)

    watch(enabled, val => (internalEnabled.value = val))

    function onEnabledChange(isEnabled: boolean) {
      emit('change', isEnabled)
    }

    return { internalEnabled, onEnabledChange }
  }
})
